// JsFromRoutes CacheKey 85d4cc30c73edcf0997330414a0ba812
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  resend: /* #__PURE__ */ definePathHelper('post', '/confirm-email-expired/resend'),
  confirm: /* #__PURE__ */ definePathHelper('post', '/confirm-new-email/confirm'),
}
